import wx from 'weixin-js-sdk';

//微信分享
var wxShare = {
  weixinShare(shareObj, result) {
    // console.log(shareObj);
    // console.log(result);
    let appid = result.appid,
      timestamp = result.timestamp,
      noncestr = result.noncestr,
      signature = result.signature,
      title = shareObj.title,
      desc = shareObj.desc,
      link = shareObj.link,
      imgUrl = shareObj.imgUrl,
      logoIndex = shareObj.logoIndex;

    // 1=觅天下，2=觅联，3=直迈房，4=觅达人
      var logoImgUrl =
        logoIndex == 1
          ? "http://m.qpic.cn/psc?/V52x3Zh31el5dB2R1Xbb3amlRD3k7Gfq/bqQfVz5yrrGYSXMvKr.cqWzi16gY0OvW8f3vNfaGzQZlbzGwHI.h10Xicr3GID5WE8gCNS.FIAhvKqT4IJ9mHfhbr0UqdDSLvu2XSpoqomQ!/mnull&bo=LAEsAQAAAAADByI!&rf=photolist&t=5"
          : logoIndex == 2
          ? "http://m.qpic.cn/psc?/V52x3Zh31el5dB2R1Xbb3amlRD3k7Gfq/bqQfVz5yrrGYSXMvKr.cqfFoCBU.VCpuClPjHf.ExPbp8bktpxFQQy84awdwMLhmxc0g*iBy0pFrZbnw8*9C1QAtf6XxUkV7ZE5TpUPYw.8!/mnull&bo=LAEsAQAAAAADByI!&rf=photolist&t=5"
            : logoIndex == 3
            ? "http://m.qpic.cn/psc?/V52x3Zh31el5dB2R1Xbb3amlRD3k7Gfq/bqQfVz5yrrGYSXMvKr.cqe1.hOZDsd3FgRTF70jwtH4DSddDYXLApXD1xZaZ*oB9RbQpvVleicUjAD0S7bzVGU93gp968oJ*Sjl3SOBRH9w!/mnull&bo=LAEsAQAAAAADByI!&rf=photolist&t=5"
              : logoIndex == 4
              ? "http://m.qpic.cn/psc?/V52x3Zh31el5dB2R1Xbb3amlRD3k7Gfq/bqQfVz5yrrGYSXMvKr.cqYvzXEyb.c2aH1B0U8ViPKgr3w9sOlvm8lT9t8lsBH6.Z1Zn5BsX5IIddiP9MURtUI.HQueU5vqkK0qCqMGQj2o!/mnull&bo=LAEsAQAAAAADByI!&rf=photolist&t=5"
                : "";

    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: appid, // 必填，公众号的唯一标识
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: noncestr, // 必填，生成签名的随机串
      signature: signature, // 必填，签名，见附录1
      jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
    });

    wx.ready(function () {
      //获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
      wx.onMenuShareTimeline({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接
        imgUrl: imgUrl || logoImgUrl, // 分享图标
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      });

      //获取“分享给朋友”按钮点击状态及自定义分享内容接口
      wx.onMenuShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接
        imgUrl: imgUrl || logoImgUrl, // 分享图标
        type: "link", // 分享类型,music、video或link，不填默认为link
        dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      });

      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    });
    
  }
}

export default wxShare;


// WEBPACK FOOTER //
// ./src/store/share.js